














































import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { IContactFormField } from '../types';
import ContactFormDropdownField from './ContactFormDropdownField.vue';
import ContactFormEnquiryField from './ContactFormEnquiryField.vue';

export default defineComponent({
  name: 'ContactFormField',
  components: {
    ContactFormEnquiryField,
    ContactFormDropdownField,
  },
  props: {
    isInDisplayFields: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object as PropType<IContactFormField>,
      required: true,
    },
    errorFields: {
      type: Array,
      required: true,
    },
    shouldResetChildren: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionSelected: '',
      errorMessage: '',
    };
  },
  computed: {
    isFieldPartOfContactForm(): boolean {
      return !this.field.isEnquirySpecific || this.isInDisplayFields;
    },
    getFieldPlaceholder(): string {
      return this.isFieldPartOfContactForm
        ? this.field.placeholder
        : `${this.field.placeholder} (Optional)`;
    },
    isTextOrEmailOrDatePickerInputField(): boolean {
      return (
        this.field.type === 'text' ||
        this.field.type === 'email' ||
        this.field.type === 'date_picker'
      );
    },
    isTextAreaField(): boolean {
      return this.field.type === 'textarea';
    },
    isEnquiryField(): boolean {
      return this.field.type === 'enquiry_type';
    },
    isDropdownField(): boolean {
      return this.field.type === 'dropdown';
    },
    isVehicleSearchField(): boolean {
      return this.field.type === 'vehicle_search';
    },
    hasErrorState(): boolean {
      return this.errorFields.includes(this.field.id) && this.field.isRequired;
    },
  },
  watch: {
    hasErrorState(newValue) {
      if (newValue) {
        this.errorMessage = 'This field is required';
      } else {
        this.errorMessage = '';
      }
    },
  },
  methods: {
    formInput(field: IContactFormField, event: Record<string, unknown>) {
      this.errorMessage = '';
      const target = event.target as HTMLInputElement;
      const inputField = field;

      if (inputField.type === 'date_picker') {
        const monthYearRegex = new RegExp('^[\\d]{2}\\s?\\/\\s?[\\d]{4}$');
        if (!monthYearRegex.test(target.value)) {
          this.errorMessage = 'Please enter date in MM/YYYY format';
          return;
        }
      }
      inputField.value = target.value;
      inputField.mappedLabel = field.label;
      this.$emit('updated-input', inputField);
    },
  },
});
